export default {"src":"/_next/static/media/grundriss-grau.78590776.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};